import { map, orderBy } from 'lodash';
import React, { Component } from 'react';
import pup from '../../../../Assets/images/pup.svg';
import Loader from '../../../Common/Component/Loader';
let temp_count_data = [1, 2, 3, 4, 5, 6, 7];
class Cleaning extends Component {

  state = {
    twice_weekly: [],
    weekly: [],
    bi_monthly: [],
    monthly: [],
    once: [],
    first_time: [],
    loader: false
  }

  componentDidMount = () => {
    //Get Standrad Cleaning
    if (this.props?.history?.location?.state) {
      this.props.getStandardCleaning({ field_office__uuid: this.props?.history?.location?.state?.query?.data?.uuid, limit: 500, offset: 0 });
      this.setState({
        loader: true
      })
    }
  }


  UNSAFE_componentWillReceiveProps = (props) => {
    let { twice_weekly, weekly, bi_monthly, monthly, once, first_time } = this.state;
    if (Object.keys(props.StandardCleaning.data).length > 0 && props.StandardCleaning.data !== this.props.StandardCleaning.data) {

      map(props.StandardCleaning.data.results, (item, i) => {
        if (item.frequency === 'twice_weekly') {
          twice_weekly.push(props.StandardCleaning.data.results[i])
        }
        if (item.frequency === 'weekly') {
          weekly.push(props.StandardCleaning.data.results[i])
        }
        if (item.frequency === 'bi_monthly') {
          bi_monthly.push(props.StandardCleaning.data.results[i])
        }
        if (item.frequency === 'monthly') {
          monthly.push(props.StandardCleaning.data.results[i])
        }
        if (item.frequency === 'once') {
          once.push(props.StandardCleaning.data.results[i])
        }
        if (item.frequency === 'first_time') {
          first_time.push(props.StandardCleaning.data.results[i])
        }

      })

      this.setState({
        twice_weekly: orderBy(twice_weekly, ['pet_count'], ['asc']),
        weekly: orderBy(weekly, ['pet_count'], ['asc']),
        bi_monthly: orderBy(bi_monthly, ['pet_count'], ['asc']),
        monthly: orderBy(monthly, ['pet_count'], ['asc']),
        once: orderBy(once, ['pet_count'], ['asc']),
        first_time: orderBy(first_time, ['pet_count'], ['asc']),
        loader: false
      })
    }
    if (Object.keys(props.StandardCleaning.errors).length > 0 && props.StandardCleaning.errors !== this.props.StandardCleaning.errors) {
      this.setState({
        loader: false
      })
    }

    if (Object.keys(props.UpdatePriceMatrix.data).length > 0 && props.UpdatePriceMatrix.data !== this.props.UpdatePriceMatrix.data) {
      this.setState({
        loader: false
      })
    }

    if (Object.keys(props.UpdatePriceMatrix.errors).length > 0 && props.UpdatePriceMatrix.errors !== this.props.UpdatePriceMatrix.errors) {
      this.setState({
        loader: false
      })
    }


  }


  //Weekly Price Change
  onPriceChange = (e, item, type) => {
    let index = type.findIndex(e => e.uuid === item.uuid);
    type[index]['price'] = e.target.value;
    this.setState({ type })
  }




  //Render Twice Weekly
  renderTwiceWeekly = () => {
    let { twice_weekly } = this.state;
    return (
      <div className="main_card_test">
        <div className="side_card">
          <div className="header">
            <img src={pup} alt="" />
          </div>
          <ul>
            <li><label></label></li>
            {
              map(temp_count_data, (item, i) => {
                return (<li key={i}> <span className="row_count">{item}</span></li>)
              })
            }
          </ul>
        </div>
        <div className="card">
          <div className="card-title"><h5>Twice Weekly</h5></div>
          <div className="card-body">
            <ul className="clean_list">
              <li>
                <label className="no-wrap">Town House</label>
                <label className="no-wrap">Detached</label>
              </li>
            </ul>

            <div className="new_price_grid_list">

              <div className="left">
                {
                  map(twice_weekly, (item, i) => {
                    if (item.property_type === "townhouse") {
                      return (
                        <input
                          key={i}
                          type="text"
                          value={twice_weekly[i].price}
                          onChange={(e) => { this.onPriceChange(e, twice_weekly[i], twice_weekly) }}
                        />
                      )
                    }
                  })
                }
              </div>

              <div className="right">
                {
                  map(twice_weekly, (item, i) => {
                    if (item.property_type === "single_family_small") {
                      return (
                        <input
                          type="text"
                          key={i}
                          value={twice_weekly[i].price}
                          onChange={(e) => { this.onPriceChange(e, twice_weekly[i], twice_weekly) }} />
                      )
                    }
                  })
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  //Rende Weekly
  renderWeekly = () => {
    let { weekly } = this.state;

    return (
      <div className="main_card_test">
        <div className="side_card">
          <div className="header">
            <img src={pup} alt="" />
          </div>
          <ul>
            <li><label></label></li>
            {
              map(temp_count_data, (item, i) => {
                return (<li key={i}> <span className="row_count">{item}</span></li>)
              })
            }
          </ul>
        </div>
        <div className="card">
          <div className="card-title"><h5>Weekly</h5></div>
          <div className="card-body">
            <ul className="clean_list">
              <li>
                <label className="no-wrap">Town House</label>
                <label className="no-wrap">Detached</label>
              </li>

            </ul>

            <div className="new_price_grid_list">
              <div className="left">
                {
                  map(weekly, (item, i) => {
                    if (item.property_type === "townhouse") {
                      return (
                        <input
                          type="text"
                          key={i}
                          value={weekly[i].price}
                          onChange={(e) => { this.onPriceChange(e, weekly[i], weekly) }} />
                      )
                    }
                  })
                }
              </div>
              <div className="right">
                {
                  map(weekly, (item, i) => {
                    if (item.property_type === "single_family_small") {
                      return (
                        <input
                          type="text"
                          key={i}
                          value={weekly[i].price}
                          onChange={(e) => { this.onPriceChange(e, weekly[i], weekly) }}
                        />
                      )
                    }
                  })
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  //Render Bi Monthly
  renderBiMonthly = () => {
    let { bi_monthly } = this.state;
    return (
      <div className="main_card_test">
        <div className="side_card">
          <div className="header">
            <img src={pup} alt="" />
          </div>
          <ul>
            <li><label></label></li>
            {
              map(temp_count_data, (item, i) => {
                return (<li key={i}> <span className="row_count">{item}</span></li>)
              })
            }

          </ul>
        </div>
        <div className="card">
          <div className="card-title"><h5>Every Other Week</h5></div>
          <div className="card-body">
            <ul className="clean_list">
              <li>
                <label className="no-wrap">Town House</label>
                <label className="no-wrap">Detached</label>
              </li>
            </ul>

            <div className="new_price_grid_list">
              <div className="left">

                {
                  map(bi_monthly, (item, i) => {
                    if (item.property_type === "townhouse") {
                      return (
                        <input
                          type="text"
                          key={i}
                          value={bi_monthly[i].price}
                          onChange={(e) => { this.onPriceChange(e, bi_monthly[i], bi_monthly) }} />
                      )
                    }
                  })
                }
              </div>
              <div className="right">
                {
                  map(bi_monthly, (item, i) => {
                    if (item.property_type === "single_family_small") {
                      return (
                        <input
                          type="text"
                          key={i}
                          value={bi_monthly[i].price}
                          onChange={(e) => { this.onPriceChange(e, bi_monthly[i], bi_monthly) }} />
                      )
                    }
                  })
                }
              </div>
            </div>

          </div>
        </div>
      </div>
    )
  }


  //Render Monthly
  renderMonthly = () => {
    let { monthly } = this.state;
    return (
      <div className="main_card_test">
        <div className="side_card">
          <div className="header">
            <img src={pup} alt="" />
          </div>
          <ul>
            <li><label></label></li>
            {
              map(temp_count_data, (item, i) => {
                return (<li key={i}> <span className="row_count">{item}</span></li>)
              })
            }
          </ul>
        </div>
        <div className="card">
          <div className="card-title"><h5>Monthly</h5></div>
          <div className="card-body">
            <ul className="clean_list">
              <li>
                <label className="no-wrap">Town House</label>
                <label className="no-wrap">Detached</label>
              </li>
            </ul>

            <div className="new_price_grid_list">
              <div className="left">
                {map(monthly, (item, i) => {
                  if (item.property_type === "townhouse") {
                    return (
                      <input
                        type="text"
                        key={i}
                        value={monthly[i].price}
                        onChange={(e) => { this.onPriceChange(e, monthly[i], monthly) }} />
                    )
                  }

                })}

              </div>
              <div className="right">
                {map(monthly, (item, i) => {
                  if (item.property_type === "single_family_small") {
                    return (
                      <input
                        type="text"
                        key={i}
                        value={monthly[i].price}
                        onChange={(e) => { this.onPriceChange(e, monthly[i], monthly) }} />
                    )
                  }

                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  // Render One Time Service
  renderOnceTimeService = () => {
    let { once } = this.state;
    let temp_count_data = [1, 2, 3, 4, 5, 6, 7];
    return (
      <div className="main_card_test">
        <div className="side_card">
          <div className="header">
            <img src={pup} alt="" />
            <ul>
              <li><label></label></li>
              {
                map(temp_count_data, (item, i) => {
                  return (<li key={i}> <span className="row_count">{item}</span></li>)
                })
              }
            </ul>
          </div>

        </div>
        <div className="card">
          <div className="card-body">


            <div className="grid_col">
              <ul className="clean_list">
                <li><b>Cleaned less than 2 weeks ago</b></li>
                <li>
                  <label>Town House</label>
                  <label>Detached</label>
                </li>
              </ul>

              <div className="new_price_grid_list">

                <div className="left">
                  {
                    map(once, (item, i) => {
                      if (item.property_type === "townhouse" && item.last_cleaned === 'less_than_2_weeks') {
                        return (
                          <input
                            key={i}
                            type="text"
                            value={once[i].price}
                            onChange={(e) => { this.onPriceChange(e, once[i], once) }}
                          />
                        )
                      }
                    })
                  }
                </div>

                <div className="right">
                  {
                    map(once, (item, i) => {
                      if (item.property_type === "single_family_small" && item.last_cleaned === 'less_than_2_weeks') {
                        return (
                          <input
                            type="text"
                            key={i}
                            value={once[i].price}
                            onChange={(e) => { this.onPriceChange(e, once[i], once) }} />
                        )
                      }
                    })
                  }
                </div>
              </div>
            </div>


            <div className="grid_col">
              <ul className="clean_list">
                <li><b>Cleaned 1-2 months ago</b></li>
                <li>
                  <label>Town House</label>
                  <label>Detached</label>
                </li>
              </ul>
              <div className="new_price_grid_list">

                <div className="left">
                  {
                    map(once, (item, i) => {
                      if (item.property_type === "townhouse" && item.last_cleaned === '1-2_months') {
                        return (
                          <input
                            key={i}
                            type="text"
                            value={once[i].price}
                            onChange={(e) => { this.onPriceChange(e, once[i], once) }}
                          />
                        )
                      }
                    })
                  }
                </div>

                <div className="right">
                  {
                    map(once, (item, i) => {
                      if (item.property_type === "single_family_small" && item.last_cleaned === '1-2_months') {
                        return (
                          <input
                            type="text"
                            key={i}
                            value={once[i].price}
                            onChange={(e) => { this.onPriceChange(e, once[i], once) }} />
                        )
                      }
                    })
                  }
                </div>
              </div>
            </div>


            <div className="grid_col">
              <ul className="clean_list">
                <li><b>Cleaned more than 2 months ago</b></li>
                <li>
                  <label>Town House</label>
                  <label>Detached</label>
                </li>
              </ul>

              <div className="new_price_grid_list">

                <div className="left">
                  {
                    map(once, (item, i) => {
                      if (item.property_type === "townhouse" && item.last_cleaned === '2_months_or_more') {
                        return (
                          <input
                            key={i}
                            type="text"
                            value={once[i].price}
                            onChange={(e) => { this.onPriceChange(e, once[i], once) }}
                          />
                        )
                      }
                    })
                  }
                </div>

                <div className="right">
                  {
                    map(once, (item, i) => {
                      if (item.property_type === "single_family_small" && item.last_cleaned === '2_months_or_more') {
                        return (
                          <input
                            type="text"
                            key={i}
                            value={once[i].price}
                            onChange={(e) => { this.onPriceChange(e, once[i], once) }} />
                        )
                      }
                    })
                  }
                </div>
              </div>


            </div>

          </div>
        </div>
      </div>
    )
  }

  //Render First Time Service

  renderFirstTimeService = () => {
    let { first_time } = this.state;

    return (
      <div className="main_card_test">
        <div className="side_card">
          <div className="header">
            <img src={pup} alt="" />
            <ul>
              <li><label></label></li>
              {
                map(temp_count_data, (item, i) => {
                  return (<li key={i}> <span className="row_count">{item}</span></li>)
                })
              }

            </ul>
          </div>

        </div>
        <div className="card">
          <div className="card-body">


            <div className="grid_col">
              <ul className="clean_list">
                <li><b>Cleaned less than 2 weeks ago</b></li>
                <li>
                  <label>Town House</label>
                  <label>Detached</label>
                </li>
              </ul>

              <div className="new_price_grid_list">

                <div className="left">
                  {
                    map(first_time, (item, i) => {
                      if (item.property_type === "townhouse" && item.last_cleaned === 'less_than_2_weeks') {
                        return (
                          <input
                            key={i}
                            type="text"
                            value={first_time[i].price}
                            onChange={(e) => { this.onPriceChange(e, first_time[i], first_time) }}
                          />
                        )
                      }
                    })
                  }
                </div>

                <div className="right">
                  {
                    map(first_time, (item, i) => {
                      if (item.property_type === "single_family_small" && item.last_cleaned === 'less_than_2_weeks') {
                        return (
                          <input
                            type="text"
                            key={i}
                            value={first_time[i].price}
                            onChange={(e) => { this.onPriceChange(e, first_time[i], first_time) }} />
                        )
                      }
                    })
                  }
                </div>
              </div>
            </div>


            <div className="grid_col">
              <ul className="clean_list">
                <li><b>Cleaned 1-2 months ago</b></li>
                <li>
                  <label>Town House</label>
                  <label>Detached</label>
                </li>
              </ul>
              <div className="new_price_grid_list">

                <div className="left">
                  {
                    map(first_time, (item, i) => {
                      if (item.property_type === "townhouse" && item.last_cleaned === '1-2_months') {
                        return (
                          <input
                            key={i}
                            type="text"
                            value={first_time[i].price}
                            onChange={(e) => { this.onPriceChange(e, first_time[i], first_time) }}
                          />
                        )
                      }
                    })
                  }
                </div>

                <div className="right">
                  {
                    map(first_time, (item, i) => {
                      if (item.property_type === "single_family_small" && item.last_cleaned === '1-2_months') {
                        return (
                          <input
                            type="text"
                            key={i}
                            value={first_time[i].price}
                            onChange={(e) => { this.onPriceChange(e, first_time[i], first_time) }} />
                        )
                      }
                    })
                  }
                </div>
              </div>
            </div>


            <div className="grid_col">
              <ul className="clean_list">
                <li><b>Cleaned more than 2 months ago</b></li>
                <li>
                  <label>Town House</label>
                  <label>Detached</label>
                </li>
              </ul>

              <div className="new_price_grid_list">

                <div className="left">
                  {
                    map(first_time, (item, i) => {
                      if (item.property_type === "townhouse" && item.last_cleaned === '2_months_or_more') {
                        return (
                          <input
                            key={i}
                            type="text"
                            value={first_time[i].price}
                            onChange={(e) => { this.onPriceChange(e, first_time[i], first_time) }}
                          />
                        )
                      }
                    })
                  }
                </div>

                <div className="right">
                  {
                    map(first_time, (item, i) => {
                      if (item.property_type === "single_family_small" && item.last_cleaned === '2_months_or_more') {
                        return (
                          <input
                            type="text"
                            key={i}
                            value={first_time[i].price}
                            onChange={(e) => { this.onPriceChange(e, first_time[i], first_time) }} />
                        )
                      }
                    })
                  }
                </div>
              </div>


            </div>

          </div>
        </div>
      </div>
    )
  }


  //Update Price Matrix
  updatePriceMatrix = () => {
    let { twice_weekly, weekly, bi_monthly, monthly, once, first_time } = this.state;

    let data = [];

    data.push(...twice_weekly, ...weekly, ...bi_monthly, ...monthly, ...once, ...first_time)

    let temp_data = []
    map(data, (item) => {
      temp_data.push({ uuid: item.uuid, price: item.price })
    })
    this.setState({
      loader: true
    })

    // Update API
    this.props.updateStandardCleaning(temp_data);
  }




  render() {
    let { loader } = this.state;

    return (
      <div className="cleaning_wrapper">
        <h4>Recurring Service</h4>

        <div className="top_card flex flex-start flex-wrap">

          {this.renderTwiceWeekly()}

          {this.renderWeekly()}


          {this.renderBiMonthly()}


          {this.renderMonthly()}

        </div>
        <div className="bottom_card">





          <div className="sider">
            <h4>One-Time Service</h4>
            {this.renderOnceTimeService()}




          </div>

          <div className="sider">
            <h4>First-Time Service</h4>
            {this.renderFirstTimeService()}



          </div>
        </div>

        <div style={{ 'float': 'right', 'paddingRight': '30px' }}>
          <button
            className="btn btn-primary"
            onClick={() => { this.updatePriceMatrix() }}
          >Update Price Matrix</button>
        </div>
        {loader ? <Loader /> : ''}
      </div>
    );
  }
}

export default Cleaning;